import React, {Component} from "react"
import {Grid, Header, Image, Button} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import Footer from "../footer";
import {setPrevRoute} from "../../actions/navigationActions";
import {connect} from "react-redux";
import STRATEGIC_PARTNER from "../../constants/strategicPartners";

const mapStateToProps = (state, ownProps) => {
    return {keepCoverage: state.anualOpenEnrollment.keepCoverage, ...ownProps}
}

class ThanksForReview extends Component {

    componentDidMount() {
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
    }

    next = () => {
        this.props.history.push(this.props.nextRoute)
    }

    render() {
        const button = <Button primary content="Next step"
                               onClick={this.next}/>;
        return (
            <React.Fragment>
                <div className="member-main-container" style={{background: 'white'}}>
                        <Grid container stackable columns={1} style={{margin: '5em'}}>
                            <Grid.Row >
                                <Grid.Column textAlign={'center'} >
                                    <Image centered style={{width: '100px'}} src="https://brella-platform-assets.s3.amazonaws.com/common/images/Success_W_Confetti%402x%402x.png"/>
                                    <Header as='h2'>Success!</Header>
                                    <p>Thanks for reviewing your personal information and family members.<br/>
                                        Now let’s adjust your {STRATEGIC_PARTNER.LABEL} coverage—</p>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    <Footer
                        showTopFooter={true} hasToDisplayCarrierDisclaimer={true}
                        button={button}
                    />
                </div>
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(ThanksForReview));
